import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { FaEdit, FaUsers, FaShoppingCart, FaCreditCard, FaEye } from 'react-icons/fa';
import { useAuth } from '../../contexts/AuthContext';
import { blogApiService } from '../../services/blogApiService';
import { orderService } from '../../services/orderService';
import { userService } from '../../services/userService';
import './Admin.css';

const AdminDashboard: React.FC = () => {
  const { user } = useAuth();
  const [stats, setStats] = useState({
    totalPosts: 0,
    draftPosts: 0,
    totalUsers: 0,
    totalOrders: 0,
    loading: true
  });

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const [posts, users, orders] = await Promise.all([
          blogApiService.getAllPosts({ limit: 1 }),
          userService.getAllUsers(1, 1),
          orderService.getAllOrders(1, 1)
        ]);

        const drafts = await blogApiService.getAllPosts({ status: 'draft', limit: 1 });

        setStats({
          totalPosts: posts.pagination.total,
          draftPosts: drafts.pagination.total,
          totalUsers: users.pagination.total,
          totalOrders: orders.pagination.total,
          loading: false
        });
      } catch (error) {
        console.error('Error fetching stats:', error);
        setStats(prev => ({ ...prev, loading: false }));
      }
    };

    fetchStats();
  }, []);

  const statCards = [
    {
      title: 'Posts Publicados',
      value: stats.totalPosts - stats.draftPosts,
      icon: <FaEdit />,
      color: '#667eea',
      link: '/admin/blog'
    },
    {
      title: 'Rascunhos',
      value: stats.draftPosts,
      icon: <FaEye />,
      color: '#f59e0b',
      link: '/admin/blog?status=draft'
    },
    {
      title: 'Usuários',
      value: stats.totalUsers,
      icon: <FaUsers />,
      color: '#10b981',
      link: '/admin/users'
    },
    {
      title: 'Pedidos',
      value: stats.totalOrders,
      icon: <FaShoppingCart />,
      color: '#8b5cf6',
      link: '/admin/orders'
    }
  ];

  return (
    <div className="admin-container">
      <div className="admin-header">
        <div>
          <h1>Dashboard Admin</h1>
          <p>Bem-vindo de volta, {user?.name}!</p>
        </div>
      </div>

      {stats.loading ? (
        <div className="loading-container">
          <div className="spinner"></div>
          <p>Carregando estatísticas...</p>
        </div>
      ) : (
        <>
          <div className="stats-grid">
            {statCards.map((card, index) => (
              <Link to={card.link} key={index} className="stat-card" style={{ borderLeftColor: card.color }}>
                <div className="stat-icon" style={{ background: `${card.color}15`, color: card.color }}>
                  {card.icon}
                </div>
                <div className="stat-content">
                  <p className="stat-title">{card.title}</p>
                  <h2 className="stat-value">{card.value}</h2>
                </div>
              </Link>
            ))}
          </div>

          <div className="quick-actions">
            <h2>Ações Rápidas</h2>
            <div className="actions-grid">
              <Link to="/admin/blog/new" className="action-card">
                <FaEdit />
                <h3>Criar Post</h3>
                <p>Escrever novo artigo para o blog</p>
              </Link>
              <Link to="/admin/blog" className="action-card">
                <FaEye />
                <h3>Gerenciar Blog</h3>
                <p>Ver e editar todos os posts</p>
              </Link>
              <Link to="/admin/users" className="action-card">
                <FaUsers />
                <h3>Gerenciar Usuários</h3>
                <p>Administrar contas de usuários</p>
              </Link>
              <Link to="/admin/orders" className="action-card">
                <FaCreditCard />
                <h3>Ver Pedidos</h3>
                <p>Histórico de compras e assinaturas</p>
              </Link>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default AdminDashboard;
